import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import { tableCustomStyles } from 'common/style/tableCustomStyle';
import React, { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import { Drawer } from 'antd';
import AddClassDetails from './AddClassDetails';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useGrade } from 'features/routine/hooks/useGrade';

interface Props {}

const ClassView: React.FC<Props> = () => {
  const [visible, setVisible] = React.useState(false);
  const grades = useSelector((state: RootState) => state.grade);
  const [reloadGrade, setReloadGrade] = React.useState(true);
  const { fetchGrade } = useGrade();

  const TableColumn = () => [
    {
      name: 'Grade',
      selector: 'grade',
      sortable: true,
    },
    {
      name: 'Start Time',
      selector: 'startTime',
      sortable: true,
    },
    {
      name: 'End Time',
      selector: 'endTime',
      sortable: true,
    },
    {
      name: 'Sections',
      selector: 'section',
      sortable: true,
    },
    // {
    //   name: 'Pass Mark',
    //   selector: 'pass_mark',
    //   sortable: true,
    // },
  ];

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const memoGradeReload = useMemo(() => reloadGrade, [reloadGrade]);

  React.useEffect(() => {
    if (memoGradeReload) {
      fetchGrade();
      setReloadGrade(false);
    }
  }, [memoGradeReload]);

  return (
    <ClassViewWrapper>
      <KPageHeader title="Grade" rightButtonTitle="Add Grade" onRightButtonClick={showDrawer} />
      <Drawer
        width={705}
        title={<h2 style={{ fontWeight: 700 }}>Add Grade</h2>}
        placement="right"
        onClose={onClose}
        visible={visible}
        closable={false}
      >
        {<AddClassDetails onVisibleChange={setVisible} onSetReloadGrade={setReloadGrade} />}
      </Drawer>
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing all the grades that are currently in this system"
      />
      <section className="dataTable">
        <DataTable
          customStyles={tableCustomStyles}
          className="data-table"
          noHeader
          highlightOnHover
          pagination
          responsive={true}
          data={grades.data.map((item) => ({
            grade: +item.id,
            startTime: item.startTime,
            endTime: item.endTime,
            section: item.sections.map((_) => _.id).join(', '),
          }))}
          columns={TableColumn()}
        />
      </section>
    </ClassViewWrapper>
  );
};

export const ClassViewWrapper = styled.div`
  padding-right: 20px;
  .dataTable {
    margin-top: 20px;
  }
`;

// const ClassView = () => <h1>Hellop</h1>;

export default ClassView;
